import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatIconModule } from '@angular/material/icon'
import { TranslateModule } from '@ngx-translate/core'
import { MonitorDataScore } from 'src/app/modules/touareg-control/services/touareg-control-state-health-monitor.service'

@Component({
  selector: 'app-generic-score-strength',
  imports: [CommonModule, MatIconModule, TranslateModule],
  templateUrl: './generic-score-strength.component.html',
  styleUrls: ['./generic-score-strength.component.scss'],
})
export class GenericScoreStrengthComponent {
  get scoreValue(): number {
    return this.score?.score ?? 0
  }

  @Input()
  score: MonitorDataScore | null | undefined

  @Input()
  scoreBoolean: boolean | null | undefined

  @Input()
  showValue!: boolean

  @Input()
  set value(val: number | string | null) {
    if (val === null) {
      this._value = null
    } else {
      this._value = typeof val === 'number' && val < 10000 ? val : '> 10000'
    }
  }

  @Input()
  suffix: string = 'ms'

  @Input()
  title!: string

  @Input()
  description!: string

  @Input()
  maximumMs!: number

  @Input()
  targetPeriodMs!: number

  @Input()
  averageLength!: number

  @Input()
  icon!: string

  get value(): string | number | null {
    return this._value
  }

  private _value: string | number | null = null

  constructor() {}
}
